/* VOL. II — early access popup
   - Shows once per visitor after a configurable delay (default 5s).
   - Suppressed via localStorage after close (reappear window, default 14d)
     or after signup (365d).
   - Native Shopify customer form submitted via fetch; falls back to a full
     submit if Shopify answers with its anti-spam challenge page.
   - Future countdown: render into [data-volii-countdown] and unhide it. */

(function () {
  'use strict';

  var STORAGE_KEY = 'vycora_volii_seen';
  var PENDING_KEY = 'vycora_volii_pending';
  var SCROLL_KEY = 'vycora_volii_scroll';
  var SUCCESS_DAYS = 365;

  function saveScrollPosition() {
    var y = String(window.pageYOffset || 0);
    storageSet(window.sessionStorage, SCROLL_KEY, y);
    storageSet(window.localStorage, SCROLL_KEY, y);
  }

  function markPending() {
    storageSet(window.sessionStorage, PENDING_KEY, '1');
    storageSet(window.localStorage, PENDING_KEY, '1');
  }

  function clearPending() {
    storageRemove(window.sessionStorage, PENDING_KEY);
    storageRemove(window.localStorage, PENDING_KEY);
  }

  function isPending() {
    return (
      storageGet(window.sessionStorage, PENDING_KEY) === '1' ||
      storageGet(window.localStorage, PENDING_KEY) === '1'
    );
  }

  function isVoliiReturnUrl() {
    return window.location.search.indexOf('volii_signup=1') !== -1;
  }

  function storageGet(storage, key) {
    try {
      return storage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function storageSet(storage, key, value) {
    try {
      storage.setItem(key, value);
    } catch (e) {
      /* storage unavailable (private mode) — popup will simply re-trigger */
    }
  }

  function storageRemove(storage, key) {
    try {
      storage.removeItem(key);
    } catch (e) {
      /* noop */
    }
  }

  function VoliiPopup(root) {
    this.root = root;
    this.dialog = root.querySelector('[data-volii-dialog]');
    this.formPanel = root.querySelector('[data-volii-form-panel]');
    this.successPanel = root.querySelector('[data-volii-success-panel]');
    this.successHeading = root.querySelector('[data-volii-success-heading]');
    this.form = root.querySelector('form');
    this.submitButton = root.querySelector('[data-volii-submit]');
    this.errorEl = root.querySelector('[data-volii-error]');
    this.defaultErrorEl = root.querySelector('[data-volii-error-default]');

    this.delayMs = (parseInt(root.dataset.delay, 10) || 0) * 1000;
    this.reappearDays = parseInt(root.dataset.reappearDays, 10) || 14;
    this.designMode = !!(window.Shopify && window.Shopify.designMode);
    this.lastFocused = null;
    this.timer = null;

    this.bindEvents();

    if (this.designMode) {
      this.bindEditorEvents();
      return;
    }

    var pending = isPending();
    var posted = root.querySelector('[data-volii-posted]');
    var voliiReturn = posted && (pending || isVoliiReturnUrl());

    if (voliiReturn) {
      clearPending();
      this.restoreScroll();
      this.persist(SUCCESS_DAYS);
      this.showSuccess();
      this.open();
      return;
    }

    if (pending && root.querySelector('[data-volii-server-error]')) {
      clearPending();
      this.restoreScroll();
      this.open();
      this.showError(root.querySelector('[data-volii-server-error]').textContent.trim());
      return;
    }

    clearPending();
    if (this.isSuppressed()) return;

    var self = this;
    this.timer = window.setTimeout(function () {
      self.open();
    }, this.delayMs);
  }

  VoliiPopup.prototype.bindEvents = function () {
    var self = this;

    this.root.querySelectorAll('[data-volii-close]').forEach(function (button) {
      button.addEventListener('click', function () {
        self.close(true);
      });
    });

    this.root.querySelector('[data-volii-overlay]').addEventListener('click', function () {
      self.close(true);
    });

    this.root.addEventListener('keyup', function (event) {
      if (event.code && event.code.toUpperCase() === 'ESCAPE') self.close(true);
    });

    if (this.form) {
      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }
  };

  VoliiPopup.prototype.bindEditorEvents = function () {
    var self = this;
    var sectionId = this.root.dataset.sectionId;

    document.addEventListener('shopify:section:select', function (event) {
      if (event.detail && event.detail.sectionId === sectionId) self.open();
    });

    document.addEventListener('shopify:section:deselect', function (event) {
      if (event.detail && event.detail.sectionId === sectionId) self.close(false);
    });
  };

  VoliiPopup.prototype.restoreScroll = function () {
    var y = parseInt(
      storageGet(window.sessionStorage, SCROLL_KEY) ||
        storageGet(window.localStorage, SCROLL_KEY),
      10
    );
    storageRemove(window.sessionStorage, SCROLL_KEY);
    storageRemove(window.localStorage, SCROLL_KEY);
    if (isNaN(y)) y = 0;

    try {
      var url = new URL(window.location.href);
      url.searchParams.delete('customer_posted');
      url.searchParams.delete('volii_signup');
      url.hash = '';
      var cleanSearch = url.searchParams.toString();
      window.history.replaceState(null, '', url.pathname + (cleanSearch ? '?' + cleanSearch : ''));
    } catch (e) {
      /* noop */
    }

    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

    var lock = function () {
      window.scrollTo(0, y);
    };
    lock();
    window.addEventListener('load', lock, { once: true });
    var frames = 0;
    (function tick() {
      lock();
      if (++frames < 24) requestAnimationFrame(tick);
    })();
  };

  VoliiPopup.prototype.isSuppressed = function () {
    var until = parseInt(storageGet(window.localStorage, STORAGE_KEY), 10);
    return !isNaN(until) && Date.now() < until;
  };

  VoliiPopup.prototype.persist = function (days) {
    if (this.designMode) return;
    storageSet(window.localStorage, STORAGE_KEY, String(Date.now() + days * 86400000));
  };

  VoliiPopup.prototype.open = function () {
    if (this.root.classList.contains('is-open')) return;

    this.lastFocused = document.activeElement;
    this.root.removeAttribute('hidden');
    this.root.classList.add('is-open');
    document.body.classList.add('overflow-hidden');

    if (typeof window.trapFocus === 'function') {
      window.trapFocus(this.root, this.dialog);
    } else {
      this.dialog.focus();
    }
  };

  VoliiPopup.prototype.close = function (persist) {
    if (!this.root.classList.contains('is-open')) return;

    this.root.classList.remove('is-open');
    this.root.setAttribute('hidden', '');
    document.body.classList.remove('overflow-hidden');

    if (typeof window.removeTrapFocus === 'function') {
      window.removeTrapFocus(this.lastFocused);
    } else if (this.lastFocused && typeof this.lastFocused.focus === 'function') {
      this.lastFocused.focus();
    }

    if (persist && !this.designMode && !this.isSuppressed()) {
      this.persist(this.reappearDays);
    }
  };

  VoliiPopup.prototype.showSuccess = function () {
    this.formPanel.setAttribute('hidden', '');
    this.successPanel.removeAttribute('hidden');
    if (this.successHeading) this.successHeading.focus();
  };

  VoliiPopup.prototype.showError = function (message) {
    var fallback = this.defaultErrorEl ? this.defaultErrorEl.textContent.trim() : '';
    this.errorEl.textContent = message || fallback;
    this.errorEl.removeAttribute('hidden');
  };

  VoliiPopup.prototype.onSubmit = function (event) {
    event.preventDefault();
    if (!this.form.reportValidity()) return;

    saveScrollPosition();

    var self = this;
    this.errorEl.setAttribute('hidden', '');
    this.submitButton.setAttribute('disabled', '');
    this.submitButton.setAttribute('aria-busy', 'true');

    fetch(this.form.action, {
      method: 'POST',
      body: new FormData(this.form),
      headers: { Accept: 'text/html' },
    })
      .then(function (response) {
        var url = response.url || '';

        if (url.indexOf('/challenge') !== -1) {
          /* Shopify anti-spam challenge: complete it with a full page flow,
             then resume via the [data-volii-posted] marker on return. */
          markPending();
          saveScrollPosition();
          self.form.submit();
          return null;
        }

        return response.text().then(function (html) {
          if (url.indexOf('customer_posted=true') !== -1) return { ok: true };

          var doc = new DOMParser().parseFromString(html, 'text/html');
          var serverError = doc.querySelector('[data-volii-server-error]');
          if (serverError) return { ok: false, message: serverError.textContent.trim() };

          return { ok: true };
        });
      })
      .then(function (result) {
        if (!result) return;
        if (result.ok) {
          self.persist(SUCCESS_DAYS);
          self.showSuccess();
        } else {
          self.showError(result.message);
        }
      })
      .catch(function () {
        self.showError();
      })
      .finally(function () {
        self.submitButton.removeAttribute('disabled');
        self.submitButton.removeAttribute('aria-busy');
      });
  };

  function init() {
    document.querySelectorAll('[data-volii-popup]').forEach(function (root) {
      if (!root.voliiPopup) root.voliiPopup = new VoliiPopup(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
